import { ModelSupportedFileTypes } from "../../types";
import { MIME_TYPE } from "../../constants";

export const isValidMimeType = (value: string): value is ModelSupportedFileTypes => value in MIME_TYPE;
